module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team_type"
    }
  }, [(_vm.$route.meta.keepAliveSub3) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "psear mb10",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'photo_in',
          params: {
            albumId: album.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n            " + _vm._s(_vm.showMemo(album)) + "\n            "), _c('div', {
      staticClass: "mt10"
    }, [_c('button', {
      staticClass: "photo_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("more")])])]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": album.coverPictureUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_title"
    }, [_vm._v(_vm._s(_vm.showName(album)))]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_tx"
    }, [_vm._v(_vm._s(_vm.showPage.totalCount) + _vm._s(album.pictureCount) + _vm._s(_vm.showPage.item))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-722a481b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeamInfo.vue
// module id = 1279
// module chunks = 4